<template>
  <aside></aside>
</template>

<script>
export default {
  name: 'HomeAside',
};
</script>

<style scoped lang="scss">
aside {
  width: 11em;
  position: sticky;
  align-self: flex-start;
  height: calc(100vh - 50px - 2em);
  top: calc(50px + 1em);
}
</style>
